export default __webpack_public_path__ + "3a7a4e95c0d37f7e642bbb741d377657.png";